import { render } from "./work-orders.vue?vue&type=template&id=87627aa0&scoped=true"
import script from "./work-orders.vue?vue&type=script&lang=js"
export * from "./work-orders.vue?vue&type=script&lang=js"

import "./work-orders.vue?vue&type=style&index=0&id=87627aa0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87627aa0"]])

export default __exports__